module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.534aec7f.jpeg";